export const comingSoonPage = () =>
  import("./ComingSoonPage").then((m) => ({ Component: m.ComingSoonPage }));
